import { render, staticRenderFns } from "./IndustrialManufacturingSolutions.vue?vue&type=template&id=f0dbf130&scoped=true"
import script from "./IndustrialManufacturingSolutions.vue?vue&type=script&lang=js"
export * from "./IndustrialManufacturingSolutions.vue?vue&type=script&lang=js"
import style0 from "./IndustrialManufacturingSolutions.vue?vue&type=style&index=0&id=f0dbf130&prod&lang=scss&scoped=true"
import style1 from "./IndustrialManufacturingSolutions.vue?vue&type=style&index=1&id=f0dbf130&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0dbf130",
  null
  
)

export default component.exports